/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Material UI
import { Tooltip, IconButton } from '@material-ui/core';

// Convert to Csv
import { CSVLink } from 'react-csv';

// Material UI Icons
import CsvIcon from 'assets/images/icons/csv.jpg';

export interface ExportToCsvProps {
  title: string;
  data: any;
}

type Props = ExportToCsvProps;

const ExportToCsv: React.FC<Props> = ({ title, data }) => {
  return (
    <CSVLink target='_blank' filename={`${title}.csv`} data={data}>
      <Tooltip title='Exportar como CSV' placement='left'>
        <IconButton aria-label='search' color='inherit'>
          <img style={{ width: '22px' }} alt='csvIcon' src={CsvIcon} />
        </IconButton>
      </Tooltip>
    </CSVLink>
  );
};

export default ExportToCsv;
export { ExportToCsv };
